import React from 'react';
import styled from 'styled-components';

import { EarnBanner } from '@/shared/components/EarnBanner/EarnBanner';
import { breakpoints } from '@/shared/styles';

const Container = styled.section`
  display: flex;
  width: 100%;
  margin-top: 64px;

  padding: 0 20px;

  @media (min-width: ${breakpoints.tabletSM}px) {
    padding: 0 16px;
  }

  @media (min-width: ${breakpoints.laptopSM}px) {
    padding: 0;
  }
`;

export const EarnBannerSection: React.FC = () => {
  return (
    <Container>
      <EarnBanner />
    </Container>
  );
};
